// extracted by mini-css-extract-plugin
module.exports = {"tabHeader":"customFields_tabHeader_19DOuaQ","tabTitle":"customFields_tabTitle_36vQrBw"};